import RangeValue from './RangeValue';

export default {
    isRangeValue: function(object) {
        return object instanceof RangeValue;
    },
    isPlainObject: function(object) {
        return Object.prototype.toString.apply(object) === '[object Object]';
    },
    isArray: function(object) {
        return Object.prototype.toString.apply(object) === '[object Array]';
    },
    isNumber: function(object, isStrong = true, isTakeNaN = false) {

        return (
            typeof(object) === 'number'
                ? isNaN(object)
                    ? isTakeNaN
                    : true
                : !isStrong && !isNaN(parseFloat(object))
        );
    },
    isString: function(object) {
        return typeof(object) === 'string';
    },
    isBoolean: function(object) {
        return typeof(object) === 'boolean';
    },
    isScalar: function(object) {
        return
            this.isString(object) ||
            this.isBoolean(object) ||
            this.isNumber(object) ||
            false
    },
    isDefined: function(object) {
        return !(object === undefined || object === null)
    },
    isEmpty: function(object) {
        return !(
               this.isDefined(object)
            || (this.isArray(object) && object.length)
            || (this.isPlainObject(object) && Object.keys(object).length)
            || (this.isString(object) && object.length)
            || (this.isNumber(object, true, true) && !isNaN(object))
            || (this.isBoolean(object))
        );
    },
    isNotEmptyArray: function(object) {
        return (this.isArray(object) && object.length);
    },
    isNotEmptyPlainObject: function(object) {
        return (this.isPlainObject(object) && Object.keys(object).length);
    }
}